var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBedge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 29,
    viewBox: "0 0 71 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 28,
    rx: 4.5,
    fill: "#F91F3E",
    fillOpacity: 0.15,
    stroke: "#F91F3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0036 9.09091V20H18.4908L12.9457 11.9993H12.8445V20H11.1985V9.09091H12.7219L18.2724 17.1023H18.3736V9.09091H20.0036ZM22.4046 20V9.09091H29.2441V10.5078H24.0505V13.8317H28.8872V15.2433H24.0505V18.5831H29.308V20H22.4046ZM33.5787 20L30.5531 9.09091H32.2843L34.4096 17.5391H34.5108L36.7214 9.09091H38.4366L40.6472 17.5444H40.7484L42.8684 9.09091H44.6049L41.574 20H39.9174L37.6216 11.8288H37.5364L35.2406 20H33.5787Z",
    fill: "#F91F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6666 18.3334L57 15L53.6666 11.6667",
    stroke: "#F91F3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18.3334L52.3333 15L49 11.6667",
    stroke: "#F91F3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBedge);
export default __webpack_public_path__ + "static/media/new-bedge.822ba42d77f7d317e2c8dfbbea99804d.svg";
export { ForwardRef as ReactComponent };